import { privateApi } from '@/modules/shared/api/api.private';

export async function createEvent({ name, startAt }) {
  const { data } = await privateApi({
    method: 'POST',
    url: '/events',
    data: { name, startAt },
  });

  return { event: data };
}

export async function inviteToEvent({ eventId, emails }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/events/${eventId}/invite`,
    data: { emails },
  });
  return { event: data };
}

export async function fetchEvents() {
  const { data } = await privateApi({
    method: 'GET',
    url: '/events',
  });
  return { events: data };
}

export async function fetchOneEvent({ eventId }) {
  const { data } = await privateApi({
    method: 'GET',
    url: `/events/${eventId}`,
  });
  return { event: data };
}

export async function lockEvent({ eventId }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/events/${eventId}/lock`,
  });
  return { event: data };
}

export async function updateEventParticipant({ eventId, userId, label }) {
  await privateApi({
    method: 'PATCH',
    url: `/events/${eventId}/participants`,
    data: {
      userId,
      label,
    },
  });
}

export async function deleteEventParticipant({ eventId, userId }) {
  await privateApi({
    method: 'DELETE',
    url: `/events/${eventId}/participants`,
    data: {
      userId,
    },
  });
}

export async function createEventRule({ eventId, name, condition }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/events/${eventId}/rules`,
    data: {
      name,
      condition,
    },
  });
  return { rule: data };
}

export async function deleteEventRule({ eventId, ruleId }) {
  await privateApi({
    method: 'DELETE',
    url: `/events/${eventId}/rules`,
    data: {
      ruleId,
    },
  });
}

export async function updateEventRule({ eventId, ruleId, condition, name }) {
  await privateApi({
    method: 'PATCH',
    url: `/events/${eventId}/rules`,
    data: {
      ruleId,
      condition,
      name,
    },
  });
}

export async function cancelEvent({ eventId }) {
  await privateApi({
    method: 'DELETE',
    url: `/events/${eventId}`,
  });
}

export async function consumeInvitation({ invitationCode }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/events/join`,
    data: {
      invitationCode,
    },
  });
  return { event: data };
}

export async function createEventInvitation({ eventId }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/events/${eventId}/invitations`,
  });
  return { invitation: data };
}

export async function fetchEventInvitations({ eventId }) {
  const { data } = await privateApi({
    method: 'GET',
    url: `/events/${eventId}/invitations`,
  });
  return { invitations: data };
}

export async function fetchEventParticipants({ eventId }) {
  const { data } = await privateApi({
    method: 'GET',
    url: `/events/${eventId}/participants`,
  });
  return { participants: data };
}
